import styled from 'styled-components'
import { H6 } from '@components/Text'

export default styled(H6)`
  text-transform: capitalize;
  font-weight: 700;
  line-height: 80px;
`
